const pixPaymentType = {
  IMMEDIATE: 'IMMEDIATE',
  FRAUD: 'FRAUD',
  SCHEDULED: 'SCHEDULED',
  DEFAULT: 'IMMEDIATE'
};

module.exports = pixPaymentType;
